import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
const firebaseConfig = {
  apiKey: "AIzaSyAXpd6-hhv2UHiRLYY6hF7aZ8yymXJ_rAc",
  authDomain: "player-ecfe6.firebaseapp.com",
  projectId: "player-ecfe6",
  storageBucket: "player-ecfe6.appspot.com",
  messagingSenderId: "361992734376",
  appId: "1:361992734376:web:27248f1bac4907d7b5e49d"
};

firebase.initializeApp(firebaseConfig);

const projectFirestore = firebase.firestore();
const projectAuth = firebase.auth();
const projectStorage = firebase.storage();

const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectFirestore, projectAuth, projectStorage, timestamp };